import React, { useEffect, useState } from "react";
import FilterHeader from "../FilterHeader";
import TabHeaders from "../TabHeaders";
import CriteriaRow from "./CriteriaRow";
import styles from "./CriteriaPanel.module.css";
import CriteriaCreation from "../criteria-creation/CriteriaCreation";
import { useApi } from "../../../../../../common/hooks";
import { FormStudioService } from "../../../../../../api";

export default function CriteriaPanel({ onSelectPanel }) {
	const [search, setSearch] = useState("");
	const [count, setCount] = useState(0);
	const [criteria, setCriteria] = useState([]);
	const [openCreation, setOpenCreation] = useState(false);
	const [sortDirection, setSortDirection] = useState("desc");
	const [sortKey, setSortKey] = useState("");
	const { call: getAllCriteria } = useApi(FormStudioService.getAllCriteria);
	const { call: deleteCriteria } = useApi(FormStudioService.deleteCriteria);
	const { call: duplicateCriteria } = useApi(FormStudioService.duplicateCriteria);

	useEffect(() => {
		getAllCriteria({ name: search })
			.then((data) => setCriteria(data.filter((element) => !!element?.type)))
			.catch(console.error);
	}, [getAllCriteria, search, count]);
	const handleOpen = () => {
		setOpenCreation((prev) => !prev);
	};
	const handleChangeFilters = ({ name }) => {
		setSearch(name);
	};
	const handleRefresh = () => {
		setCount((prev) => prev + 1);
	};
	const handleDeleteCriteria = (row) => {
		deleteCriteria({ fieldId: row.id }).then(handleRefresh).catch(console.error);
	};
	const handleDuplicateCriteria = (row) => {
		duplicateCriteria({ fieldId: row.id }).then(handleRefresh).catch(console.error);
	};
	const rowRenderer = (criterion) => (
		<CriteriaRow
			key={criterion.id}
			criteria={criterion}
			onDelete={handleDeleteCriteria}
			onDuplicate={handleDuplicateCriteria}
			onRefresh={handleRefresh}
			onSelectPanel={onSelectPanel}
		/>
	);
	const handleClickSort = (newKey) => {
		if (newKey === sortKey) {
			setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
		} else {
			setSortKey(newKey);
			setSortDirection("asc");
		}
	};
	return (
		<div className={styles.main}>
			<FilterHeader
				actionTitle="dsi.form-studio.criteria.new.button"
				onChangeFilters={handleChangeFilters}
				onOpen={handleOpen}
			/>
			<TabHeaders panel={1} sortDirection={sortDirection} sortKey={sortKey} onClickSort={handleClickSort} />
			<div className={styles.list}>{criteria.map((row) => rowRenderer(row))}</div>
			<CriteriaCreation open={openCreation} onClose={handleOpen} onRefresh={handleRefresh} />
		</div>
	);
}
